export interface HeaderProps {
  className?: string
  primaryCta?: { title: string; url: string }
  secondaryCta?: { title: string; url: string }
  tertiaryCta?: { title: string; url: string }
  showNavLinks?: boolean
  mode: 'dark' | 'light'
  categoriesData: CategoriesDropdownProps
}

// data
export interface CategoriesDropdownProps {
  links: {
    title: string
    description: string
    icon: string
    slug: string
  }[]
}
export const categoriesData = {
  links: [
    {
      title: 'Content Strategy',
      slug: '/blog/category/content-strategy/',
      type: 'text',
      description:
        'Uncover tips and tactics to create content that aligns with your business goals.',
      icon: '/assets/icons/blog/content_strategy.svg'
    },
    {
      title: 'Content Operations',
      slug: '/blog/category/content-operations/',
      type: 'text',
      description:
        'Streamline your content  process and enhance team collaboration.',
      icon: '/assets/icons/blog/content_operations.svg'
    },
    {
      title: 'Content Analytics',
      slug: '/blog/category/content-analytics/',
      type: 'text',
      description:
        'Dive into the data to measure  impact and make data-driven decisions.',
      icon: '/assets/icons/blog/content_analytics.svg'
    },
    {
      title: 'Demand Generation',
      slug: '/blog/category/demand-generation/',
      type: 'text',
      description:
        'Learn how to convert leads into customers with targeted marketing strategies.',
      icon: '/assets/icons/blog/demand_generation.svg'
    },
    {
      title: 'Organic Marketing',
      slug: '/blog/category/organic-marketing/',
      type: 'text',
      description:
        'Master the art of growing your brand and building a loyal audience.',
      icon: '/assets/icons/blog/organic_marketing.svg'
    },
    {
      title: 'Generative AI',
      slug: '/blog/category/generative-ai/',
      type: 'text',
      description:
        'Explore the cutting-edge world of AI-generated content and its potential applications.',
      icon: '/assets/icons/blog/generative_ai.svg'
    },
    {
      title: 'Video Marketing',
      slug: '/blog/category/video-marketing/',
      type: 'text',
      description:
        'Harness the power of video to engage your audience and drive meaningful results.',
      icon: '/assets/icons/blog/video_marketing.svg'
    },
    {
      title: 'Data and Studies',
      slug: '/blog/category/data-and-studies/',
      type: 'text',
      description:
        'Gain insights from industry studies to inform your marketing decisions.',
      icon: '/assets/icons/blog/data_and_studies.svg'
    },
    {
      title: 'Product',
      slug: '/blog/category/product/',
      type: 'text',
      description:
        'Stay updated with the latest product developments, features from Pepper.',
      icon: '/assets/icons/blog/product.svg'
    }
  ]
}
